import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'PageHeader' })((theme) => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    alignSelf: 'stretch',
    // Spacing between title / optional blocks uses Stack `spacing` (gap), not child margins,
    // so omitted elements (e.g. no divider) do not leave extra space.
  },
  titleStack: {
    width: '100%',
  },
  title: {
    flex: 1,
    minWidth: 0,
  },
  /** Linked title (see `titleHref` prop) */
  titleAsLink: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.primary
        : theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
      textDecoration: 'none',
    },
  },
  description: {
    margin: 0,
  },
}));
